module.exports = __webpack_public_path__ + "static/media/stone.3b9702b1.jpg";